import styled, { css } from 'styled-components';

import theme from '$/assets/theme';

const StyledLabel = styled.div<{ extended: boolean }>`
  display: grid;
  grid-template-columns: 32px 1fr;
  grid-gap: 12px;
  align-items: center;
  padding: 16px;
  border: 1px dashed ${theme.colors.brandBlue};
  border-radius: 2rem;
  color: ${theme.colors.grey7};
  cursor: pointer;
  transition: all ${theme.transitions.normal};

  &:hover {
    background: ${theme.colors.brandBlue10};
  }

  &:focus {
    outline: none;
  }

  ${(props) =>
    props.extended &&
    css`
      padding-bottom: 48px;
      background: ${theme.colors.brandBlue10};
    `};

  @media (max-width: ${theme.breakpoints.sm}) {
    border: none;
    padding: 8px 16px;
  }
`;

export default StyledLabel;
